interface Props {
  [key: string]: any
}

export default function HomChatCircleIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 65 65" {...rest} xmlns="http://www.w3.org/2000/svg">
      <circle cx="32.5" cy="32.5" fill="#ff9b05" r="31.44" stroke="white" strokeWidth="2.12" />
      <path
        d="M33.487 16C24.7069 16 17.5897 23.2003 17.5897 32.0829C17.5897 35.0076 18.3735 37.7417 19.7215 40.1042L16.0938 48.4545C15.6916 49.3801 16.6589 50.304 17.5492 49.8457L25.3023 45.8515C27.6956 47.311 30.4895 48.1658 33.487 48.1658C42.267 48.1658 49.3842 40.9655 49.3842 32.0829C49.3842 23.2003 42.267 16 33.487 16Z"
        fill="white"
      />
      <path
        d="M33.4862 33.6912C34.3642 33.6912 35.0759 32.9711 35.0759 32.0829C35.0759 31.1947 34.3642 30.4746 33.4862 30.4746C32.6082 30.4746 31.8965 31.1947 31.8965 32.0829C31.8965 32.9711 32.6082 33.6912 33.4862 33.6912Z"
        fill="#7D38D6"
      />
      <path
        d="M27.1288 33.6912C28.0068 33.6912 28.7185 32.9711 28.7185 32.0829C28.7185 31.1947 28.0068 30.4746 27.1288 30.4746C26.2508 30.4746 25.5391 31.1947 25.5391 32.0829C25.5391 32.9711 26.2508 33.6912 27.1288 33.6912Z"
        fill="#7D38D6"
      />
      <path
        d="M39.8475 33.6912C40.7255 33.6912 41.4373 32.9711 41.4373 32.0829C41.4373 31.1947 40.7255 30.4746 39.8475 30.4746C38.9696 30.4746 38.2578 31.1947 38.2578 32.0829C38.2578 32.9711 38.9696 33.6912 39.8475 33.6912Z"
        fill="#7D38D6"
      />
    </svg>
  )
}
